















































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateWorkerPermDesiredDetailsRequest from '@/models/Workers/UpdateWorkerPermDesiredDetailsRequest';

@Component({
    name: 'WorkerPermCurrentDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public worker = new WorkerDto();
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      if (AgencySettingsModule.positions) {
        await AgencySettingsModule.getPositions();
      }
    }
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateWorkerPermDesiredDetailsRequest()
    request.updatedAt = this.worker.updatedAt;
    request.desiredAnnualSalary = this.worker.desiredAnnualSalary;
    await WorkerDetailsModule.editPermDesiredDetails(request);
    this.dialog = false;
  }
}
